import type { Complexity, Feature } from "./schemas.js";

/**
 * Score complexity heuristically if not explicitly set.
 * Uses description length, dependency count, and task count as signals.
 */
export function scoreComplexity(feature: Feature): Complexity {
  // If already set from spec, trust it
  if (feature.complexity) return feature.complexity;

  let score = 0;

  // Description length as a proxy for scope
  if (feature.description.length > 200) score += 2;
  else if (feature.description.length > 100) score += 1;

  // Dependencies increase complexity
  score += Math.min(feature.dependencies.length, 3);

  // More AI tasks = more complex
  score += Math.min(feature.aiTasks.length, 3);

  if (score <= 1) return "S";
  if (score <= 3) return "M";
  if (score <= 5) return "L";
  return "XL";
}
